import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class StartTimingRecordModel extends Model 
{
	@attr('date') assignedStartTime;
	@attr('boolean',{defautValue: true}) participatesInAutoAssociation;
	
	@belongsTo('timing-impulse', {inverse: null, async: true}) startImpulseId;
	@belongsTo('entry', {inverse:'StartTimingRecordId', async: true}) EntryId;
	@belongsTo('event', {inverse: 'startTimingRecords', async: true}) EventId;
}